﻿import { OpaccFilterCriterias } from './opacc.class.filter-criterias.js';

export const opaccFilterCriterias = new OpaccFilterCriterias();
window.opaccFilterCriterias = opaccFilterCriterias;